import axios from "@/plugins/Axios";

const model = "conekta";

function findOrder(id) {
  return axios.get(`${process.env.VUE_APP_API_URL}/${model}/orders/${id}`);
}

export { findOrder };
